import graphqlClient from '~/graphql/graphqlClient';
import type {
  MutationEquipBagToGlobalBagSlotArgs,
  ItemMoveResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation EquipBagToGlobalBagSlot(
  $playerId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  equipBagToGlobalBagSlot(
    playerId: $playerId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export default async function mutationEquipBagToGlobalBagSlot(
  args: MutationEquipBagToGlobalBagSlotArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>('equipBagToGlobalBagSlot', mutation, args);
}
